// Vendor
import { ref } from 'vue';
import { defineStore } from 'pinia';
// Globals
import { API_PREFIX } from '../../endpoints';
// Stores
import { useContextStore } from '../../../context';
import { useNavigation } from '../../../nav/module';
const useSyliusShopTaxonList = defineStore('shopTaxonList', () => {
    // Composable
    const { $api, $endpoints } = useContextStore();
    const nav = useNavigation();
    // Refs
    const items = ref({
        limit: 0,
        loaded: false,
        page: 0,
        pages: 0,
        results: null,
        total: 0,
    });
    // Methods
    async function fetchItems(options) {
        const { nav: navOptions, updateState = true } = options || {};
        if (updateState) {
            items.value.loaded = false;
            items.value.results = [];
        }
        const response = await $api
            .get(`${API_PREFIX.SHOP}${$endpoints.TAXONS}`)
            .catch((error) => Promise.reject(error));
        const { data } = response;
        if (data) {
            if (updateState) {
                items.value.results = data;
                items.value.loaded = true;
            }
            if (navOptions) {
                const _navOptions = typeof navOptions === 'boolean'
                    ? {
                        location: 'taxon-menu',
                        routeBase: {
                            name: 'taxon-child',
                        },
                    }
                    : navOptions;
                nav.register(_navOptions.location, data.map((taxon) => ({
                    label: `${taxon.name}`,
                    link: Object.assign(Object.assign({}, _navOptions.routeBase), { params: Object.assign(Object.assign({}, _navOptions.routeBase.params), { [_navOptions.taxonCodeParam || 'taxonCode']: taxon.code }) }),
                })));
            }
            return data;
        }
        return null;
    }
    return {
        fetchItems,
        items,
    };
});
export { useSyliusShopTaxonList };
//# sourceMappingURL=list.js.map